/**
 * Formata uma data de acordo com a string passada
 * @param {Date} date Date obj da data a ser formatada
 * @returns {String}
 */

export const formatDate = (isoDate) => {
  const { format } = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
  return format(new Date(isoDate))
}

export const convertDateToISOFormat = (dateString) => {
  const [day, month, year] = dateString.split('/')
  return `${year}-${month}-${day}`
}
